import styled from 'styled-components';
import { Star, Star_01 } from '@hqo/react-components-library/dist/icons';

export const FavoritesFilterButtonContainer = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, isActive }) => (isActive ? theme.colors.palette.systemGold : theme.colors.palette.systemGreyMedium)};
  background: ${({ theme, isActive }) => (isActive ? theme.colors.palette.systemLightGold : 'transparent')};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const FilledStarIcon = styled(Star)`
  width: 18px;
  height: 18px;
  color: ${({ theme }) => theme.colors.palette.systemGold};
`;

export const OutlineStarIcon = styled(Star_01)`
  width: 18px;
  height: 18px;
  color: ${({ theme }) => theme.colors.palette.systemGreyDark};
`;
